import {
  Text,
  Box,
  Columns,
  Column,
  Card,
  Stack,
  Heading,
  ContentBlock,
} from 'braid-design-system';
import React from 'react';

import unsubscribeIcon from 'src/images/unsubscribe-icon.png';

interface Props {
  title: string;
  cardTitle: string;
  body: string;
}

const Confirmation = ({ title, cardTitle, body }: Props) => (
  <ContentBlock>
    <Box paddingY="xlarge">
      <Stack space="gutter">
        <Box paddingTop="gutter" paddingLeft={['gutter', 'gutter', 'none']}>
          <Heading level="1">{title}</Heading>
        </Box>
        <Card>
          <Columns space="gutter" alignY="center" collapseBelow="tablet">
            <Column width="content">
              <Box textAlign="center" paddingX="gutter">
                <img
                  alt="unsubscribe-icon"
                  style={{
                    width: '88px',
                  }}
                  src={unsubscribeIcon}
                />
              </Box>
            </Column>
            <Column width="3/4">
              <Stack space="medium">
                <Heading level="3">{cardTitle}</Heading>
                <Text>{body}</Text>
              </Stack>
            </Column>
          </Columns>
        </Card>
      </Stack>
    </Box>
  </ContentBlock>
);

export default Confirmation;
